import type { Access } from '@thinkalpha/access-ws-client/contracts/user.js';
import type { PermissionType } from '@thinkalpha/common/contracts/permissions.js';
import type { FirmParent, FirmWithParentsAndChildren } from '@thinkalpha/ui-types/types/admin/firms';

export type AdminParent = FirmParent & { permission: Extract<PermissionType, 'admin' | 'owner'> };

/**
 * Returns parent firms on which the current user holds admin or owner access.
 * Pure: takes the firm and the user's access list and computes the result —
 * no React, no hooks, no I/O — so it can be unit-tested directly.
 */
export function getAdminParents(
    firm: FirmWithParentsAndChildren,
    accessList: Access[] | undefined,
): readonly AdminParent[] {
    if (!accessList || firm.parents.length === 0) return [];

    return firm.parents.flatMap((parent) => {
        const access = accessList.find((a) => a.type === 'firm' && a.id === parent.id);
        if (access?.permission !== 'admin' && access?.permission !== 'owner') return [];
        return [{ ...parent, permission: access.permission }];
    });
}
